import React from "react";
import tokenService from '../../../../utils/tokenDecoder';
import {
  Box, Card, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';
import moment from 'moment';

const options = {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export default class ComponentToPrint extends React.Component {

  render() {
    const searchData = this.props.searchData;
    const searchDate = this.props.searchDate;
    const factoryCropData = this.props.factoryCropData;
    const prevTotalSupp = this.props.prevTotalSupp;
    const curTotalSupp = this.props.curTotalSupp;
    const prevTotalCrop = this.props.prevTotalCrop;
    const curTotalCrop = this.props.curTotalCrop;


    return (
      <div>
        <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
          <br />
          <h2><center><u>Factory Crop Comparison Monthly Report</u></center></h2>
          <div>&nbsp;</div>
          <h3><center>Group: {searchData.groupName}</center></h3>
          <h3><center>{(searchDate.year === '' ? moment(new Date()).format('YYYY') : searchDate.year) - 1}/{searchDate.month === '' ? moment(new Date()).format('MMM') : searchData.monthName} - {searchDate.year === '' ? moment(new Date()).format('YYYY') : searchDate.year}/{searchDate.month === '' ? moment(new Date()).format('MMM') : searchData.monthName}</center></h3>
          <div>&nbsp;</div>
          <div>
            <Box minWidth={1050}>
              <TableContainer style={{ marginLeft: '0rem' }} >
                <Table aria-label="caption table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align={'center'} style={{ borderRight: "1px solid #ccc", borderLeft: "1px solid #ccc", borderTop: "1px solid #ccc", borderBottom: 'none' }}>Factory</TableCell>
                      <TableCell align={'center'} colSpan={2} style={{ borderRight: "1px solid #ccc", borderTop: "1px solid #ccc" }}>{(searchDate.year === '' ? moment(new Date()).format('YYYY') : searchDate.year) - 1}/{searchDate.month === '' ? moment(new Date()).format('MMM') : searchData.monthName}</TableCell>

                      <TableCell align={'center'} colSpan={2} style={{ borderRight: "1px solid #ccc", borderTop: "1px solid #ccc" }}>{searchDate.year === '' ? moment(new Date()).format('YYYY') : searchDate.year}/{searchDate.month === '' ? moment(new Date()).format('MMM') : searchData.monthName}</TableCell>

                      <TableCell align={'center'} style={{ borderRight: "1px solid #ccc", borderTop: "1px solid #ccc", borderBottom: 'none' }}>Supplier Variance</TableCell>
                      <TableCell align={'center'} style={{ borderRight: "1px solid #ccc", borderTop: "1px solid #ccc", borderBottom: 'none' }}>Crop Variance</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align={'left'} style={{ borderRight: "1px solid #ccc", borderLeft: "1px solid #ccc" }}></TableCell>
                      <TableCell align={'right'} style={{ borderRight: "1px solid #ccc" }}>Active Suppliers</TableCell>
                      <TableCell align={'right'} style={{ borderRight: "1px solid #ccc" }}>Crop (Kg)</TableCell>
                      <TableCell align={'right'} style={{ borderRight: "1px solid #ccc" }}>Active Suppliers</TableCell>
                      <TableCell align={'right'} style={{ borderRight: "1px solid #ccc" }}>Crop (Kg)</TableCell>
                      <TableCell align={'left'} style={{ borderRight: "1px solid #ccc" }}></TableCell>
                      <TableCell align={'left'} style={{ borderRight: "1px solid #ccc" }}></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {factoryCropData.map((data, index) => (
                      <TableRow key={index} style={{ borderBottom: "1px solid #ccc" }}>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderRight: "1px solid #ccc", borderBottom: "none", borderLeft: "1px solid #ccc" }}>
                          {data.factoryName}
                        </TableCell>
                        <TableCell align={'right'} component="th" scope="row" style={{ borderRight: "1px solid #ccc", borderBottom: "none" }}>
                          {data.prevYearSupplierCount}
                        </TableCell>
                        <TableCell align={'right'} component="th" scope="row" style={{ borderRight: "1px solid #ccc", borderBottom: "none" }}>
                          {data.prevYearWeight.toLocaleString('en-US', options)}
                        </TableCell>
                        <TableCell align={'right'} component="th" scope="row" style={{ borderRight: "1px solid #ccc", borderBottom: "none" }}>
                          {data.currentYearSupplierCount}
                        </TableCell>
                        <TableCell align={'right'} component="th" scope="row" style={{ borderRight: "1px solid #ccc", borderBottom: "none" }}>
                          {data.currentYearWeight.toLocaleString('en-US', options)}
                        </TableCell>
                        <TableCell align={'right'} component="th" scope="row" style={{ borderRight: "1px solid #ccc", borderBottom: "none" }}>
                          {(data.currentYearSupplierCount - data.prevYearSupplierCount)}
                        </TableCell>
                        <TableCell align={'right'} component="th" scope="row" style={{ borderRight: "1px solid #ccc", borderBottom: "none" }}>
                          {(data.currentYearWeight - data.prevYearWeight).toLocaleString('en-US', options)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableRow>
                    <TableCell align={'left'} style={{ borderLeft: "1px solid #ccc" }} ><b>Total</b></TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderRight: "1px solid #ccc", borderLeft: "1px solid #ccc", borderBottom: "1px solid #ccc", borderTop: "1px solid #ccc" }}>
                      <b>{prevTotalSupp}</b>
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", borderTop: "1px solid #ccc" }}>
                      <b>{prevTotalCrop.toLocaleString('en-US', options)}</b>
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", borderTop: "1px solid #ccc" }}>
                      <b> {curTotalSupp} </b>
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", borderTop: "1px solid #ccc" }}>
                      <b> {curTotalCrop.toLocaleString('en-US', options)} </b>
                    </TableCell>
                  </TableRow>
                </Table>
              </TableContainer>
            </Box>
          </div>
        </div></div>
    );
  }
}

